import { render, staticRenderFns } from "./RadioButtonQuestion.vue?vue&type=template&id=a6701bfa&scoped=true&"
import script from "./RadioButtonQuestion.vue?vue&type=script&lang=js&"
export * from "./RadioButtonQuestion.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonQuestion.vue?vue&type=style&index=0&id=a6701bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6701bfa",
  null
  
)

export default component.exports